/**
 * Structural FAQ data — category keys + question keys. Actual question
 * and answer text lives in `dict.faqPage.categories[key].questions[qkey]`
 * so the FAQ list translates with the locale.
 */
export type FaqCategoryKey =
  | "general"
  | "development"
  | "design"
  | "process";

export interface FaqCategoryStructure {
  key: FaqCategoryKey;
  /** Question keys, matching keys in dict under this category. */
  questionKeys: string[];
}

export const faqsData: FaqCategoryStructure[] = [
  {
    key: "general",
    questionKeys: ["services", "whyChoose", "smallLarge", "seoFriendly"],
  },
  {
    key: "development",
    questionKeys: ["types", "redesign", "fixErrors", "hosting"],
  },
  {
    key: "design",
    questionKeys: ["productDesign", "androidIos", "uiVsUx", "customBrand"],
  },
  {
    key: "process",
    questionKeys: [
      "startProject",
      "contentReady",
      "revisions",
      "cost",
      "timeline",
    ],
  },
];
